export default __webpack_public_path__ + "static/image-modal-627acd23923b6ae0d0ea22d4a9101e97.jpg";